<script type="text/ecmascript-6">
    import DesignerQuestionHingeSide from "./DesignerQuestionHingeSide.vue";
    import RadioSwitchQuestion from "../mixin/RadioSwitchQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHingeSide,
            RadioSwitchQuestion,
        ],
        props: {
            title: {
                default() {
                    return 'Hinge Side: <small>(viewed from outside)</small>';
                }
            }
        }
    }
</script>
